export const ROUND_NOT_OPEN_MIN_LEFT_MS = 2000

/**
 * Go never opened the round (OpenRound expired, dead-lettered, or the odds
 * hash mismatched — A34/A68) but the widget still shows a priced board and the
 * countdown: every chip then fails with RoundClosed while the local clock says
 * betting is still closing. Flag it once, show "betting unavailable this
 * round" and log `birdie_round_not_open`; soak gate = 0.
 *
 * The anchor is `race_starting.eventTimestamp` (the same instant `useTimer`
 * counts the closing window down from) plus `game.bettingClosingWindow` — 4 s
 * for Birdie. Rejects landing inside the last 2 s of that window are the
 * ORDINARY close race (the chip left the client before Go closed the round)
 * and must stay silent, which is why the discriminator is time-left and not
 * the reason alone.
 */
export function shouldFlagRoundNotOpen(input: {
  reason?: string
  rejectionRaceId?: string
  currentRaceId?: string
  closingStartedAt?: number
  closingWindowS: number
  now: number
}): boolean {
  if (input.reason !== 'RoundClosed') return false
  if (!input.rejectionRaceId || input.rejectionRaceId !== input.currentRaceId) return false
  if (input.closingStartedAt === undefined || Number.isNaN(input.closingStartedAt)) return false
  const leftMs = input.closingStartedAt + input.closingWindowS * 1000 - input.now
  return leftMs > ROUND_NOT_OPEN_MIN_LEFT_MS
}
